// Helpers partagés pour les exports PDF (jsPDF + autoTable)

// En-tête de tableau et ligne TOTAL sans fond (texte noir gras, bordures via styles)
export const PDF_HEAD_STYLES = { fillColor: false, textColor: [0, 0, 0], fontStyle: 'bold' };
export const PDF_FOOT_STYLES = { fillColor: false, textColor: [0, 0, 0], fontStyle: 'bold' };

// Libellé d'agence pour l'en-tête PDF, en tenant compte des rôles restreints.
// - agence sélectionnée → son nom
// - utilisateur restreint (ne peut pas changer d'agence) → son agence
// - sinon → toutes les agences jointes
export function resolveAgenceLabel({ selected, agences = [], canSwitchAgence, userAgenceId, allLabel }) {
    if (selected && selected !== 'all') {
        return agences.find((a) => a._id === selected)?.nom || '';
    }
    if (!canSwitchAgence && userAgenceId) {
        return agences.find((a) => a._id === userAgenceId)?.nom || '';
    }
    if (allLabel != null) return allLabel;
    return agences.map((a) => a.nom).join(' / ') || 'TOUTES';
}

// Pied de page sur chaque page : qui a exporté + date/heure + pagination (traçabilité).
export function addExporterFooter(doc, exporterName) {
    const pageCount = doc.getNumberOfPages();
    const now = new Date();
    const stamp = `${now.toLocaleDateString('fr-FR')} ${now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}`;
    const label = `Exporté par : ${exporterName || '—'} — le ${stamp}`;
    for (let i = 1; i <= pageCount; i += 1) {
        doc.setPage(i);
        const pw = doc.internal.pageSize.getWidth();
        const ph = doc.internal.pageSize.getHeight();
        doc.setFontSize(8);
        doc.setTextColor(120);
        doc.text(label, 14, ph - 8);
        doc.text(`Page ${i}/${pageCount}`, pw - 14, ph - 8, { align: 'right' });
        doc.setTextColor(0);
    }
}
